import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/mydosoLogoWeb.png'
import _imports_1 from '@/assets/images/mydosoLogoTWWeb.png'
import _imports_2 from '@/assets/images/icons/profile-circle.png'
import _imports_3 from '@/assets/images/icons/unlock.png'
import _imports_4 from '@/assets/images/icons/wechat-login.png'
import _imports_5 from '@/assets/images/icons/line-login.png'
import _imports_6 from '@/assets/images/icons/lock-fill2.png'
import _imports_7 from '@/assets/images/icons/strick-login.png'


const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = {
  key: 0,
  class: "login-logo",
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  class: "login-logo",
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = {
  key: 2,
  class: "login-qrcode"
}
const _hoisted_5 = {
  key: 0,
  id: "login_container"
}
const _hoisted_6 = { style: {"display":"inline-flex","align-items":"center"} }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","height":"35px","line-height":"35px"} }
const _hoisted_8 = { class: "nohover" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  class: "vs-button__content",
  style: {"padding":"2px 12px"}
}
const _hoisted_11 = { class: "input-suffix" }
const _hoisted_12 = { class: "other-logins" }
const _hoisted_13 = { class: "tips-text" }

import {ArrowDown} from '@element-plus/icons-vue'
import {computed, nextTick, ref, watch} from 'vue'
import {useStore} from 'vuex'
import userService from '@/services/user'
import {setToken} from '@/utils/auth'
import {ElMessage} from 'element-plus'
import querystring from "querystring";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const {mobileLogin,getUserInfo,sendSms,userNameLogin} = userService
const store = useStore()
const showLogin = computed(() => store.state.user.showLogin || false)
console.log('showLogin', showLogin, store);

const isCode = ref(true)
const loginType = ref('mobile')
// 18842262566
// 678321
const form = ref({mobile:'',code:'',password:''})
const showModel = ref(false)
const smsLoading = ref(false)
const btnLoading = ref(false)
const formRef = ref()
const rules = ref({
  mobile: { required: true, message: '请输入手机号', trigger: 'blur' },
  code: { required: true, message: '请输入验证码', trigger: 'blur' },
  password: { required: true, message: '请输入密码', trigger: 'blur' },
})
const countryCode = computed(() => store.state.user.language === 'zh-CN' ? '86': '886')
const isQuickLogon = ref(false)
const dropdownSelectedPlatform = (val) => {
  store.dispatch('user/setPlatform', val === '86' ? 'zh-CN': 'zh-TW')
  store.dispatch('user/setLanguage',  val === '86' ? 'zh-CN': 'zh-TW')
}
watch(()=>showLogin,(newVal) => {
  console.log(newVal);

})
const closeDia = () => {
  store.dispatch('user/setLoginShow', false)
}
const timer:any = ref(null)
const countDown = ref(0)
const startCountDown = () => {
    // 如果倒计时没有在进行中
    if (countDown.value === 0) {
        countDown.value = 60; // 设置初始倒计时时间
        // countDown.value = 10; // 设置初始倒计时时间
        // 启动定时器，每秒更新倒计时
        timer.value = setInterval(() => {
        if (countDown.value > 0) {
            countDown.value--;
        } else {
            // 倒计时结束，清除定时器
            smsLoading.value = false;
            clearInterval(timer.value);
            timer.value = null;
        }
        }, 1000);
    }
}
const sendCode = async () => {
  if (!form.value.mobile) {
    return ElMessage.error('请输入手机号')
  }
  if(smsLoading.value){
    return ;
  }
  // if (countDown.value > 0) return
  try {
    const captcha = new TencentCaptcha('190627459', callback, {});
    captcha.show();
  } catch (error) {
    loadErrorCallback();
  }
}

function loadErrorCallback() {
  var appid = '190627459';
  var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
  callback({
    ret: 0,
    randstr: '@' + Math.random().toString(36).substr(2),
    ticket: ticket,
    errorCode: 1001,
    errorMessage: 'jsload_error',
  });
}

const tencentData = ref({})
async function callback(res) {
  tencentData.value = {...res}

  if (countDown.value > 0) return
  try {
    const params = {
      mobile: form.value.mobile,
      type: 'login', // bind_mobile 绑定手机 change_mobile_check_old 修改绑定手机 验证旧手机
      ticket: tencentData.value.ticket,
      randstr: tencentData.value.randstr,
      country_code: countryCode.value, // 86 或者 '886'
    }
    sendSms(params).then(res => {
      if(res.data.code == 0){
        smsLoading.value = true;
        startCountDown()
      }
    })
  } catch(err) {
    console.log('err',err)
  }
}

const confirmLogin = async () => {
  if (!formRef.value) return
  await formRef.value.validate((valid, fields) => {
    if (valid) {
      if (!isCode.value) {
        let params = {
          email: form.value.mobile,
          password:form.value.password,
        }
        btnLoading.value = true
        userNameLogin(params).then(res=>{
          let data = res.data.result
          store.dispatch('user/setUserInfo', data)
          store.dispatch('user/setToken', data.token)
          store.dispatch('user/setLoginShow', false)
          setToken(data.token)
          btnLoading.value = false
          getUserInfo().then(res=>{
            store.dispatch('user/setUserInfo', res.data.result)
            window.location.reload()
          })
        }).catch(err=>{
          console.log('err', err);
          btnLoading.value = false

        })
      } else {
        let params = {
          mobile: form.value.mobile,
          // password: md5(form.value.password),
          // mobile: formState.mobile,
          code: form.value.code,
          type: 'login',
          country_code: countryCode.value, // 86 或者 '886'
        }
        btnLoading.value = true
        mobileLogin(params).then(res=>{
          let data = res.data.result
          store.dispatch('user/setUserInfo', data)
          store.dispatch('user/setToken', data.token)
          store.dispatch('user/setLoginShow', false)
          setToken(data.token)
          btnLoading.value = false
          getUserInfo().then(res=>{
            store.dispatch('user/setUserInfo', res.data.result)
            window.location.reload()
          })
        }).catch(err=>{
          console.log('err');
          btnLoading.value = false

        })
      }
    }
  })
}

const wechatLogin = () => {
  loginType.value = 'wechat';
  nextTick(() => {
    var obj = new WxLogin({
      self_redirect: true,
      id:"login_container",
      appid: "wx67a1b4ee5e22f0b0",
      scope: "snsapi_login",
      redirect_uri: "https://www.mydoso.com/wechat_login",
      state: "123",
      stylelite: 1,
      onReady: function(isReady){
        console.log(isReady);
      }
    });
  })
}

const lineLogin = () => {
  const clientId = "2006147278"; // 你的 Channel ID
  const state = "12345abcde"; // 随机字符串防CSRF，生产环境请动态生成并保存session
  const nonce = "09876xyz";   // 随机字符串，用于验证id_token

  // const callback_url = window.location.origin + '/line_callback'
  const callback_url = 'https://www.mydoso.com/line_callback'
  console.log('aa', {
    response_type: "code",
    client_id: clientId,
    redirect_uri: callback_url,
    state,
    scope: "profile openid",
    nonce
  })
  const params = querystring.stringify({
    response_type: "code",
    client_id: clientId,
    redirect_uri: callback_url,
    prompt: 'login',
    initial_amr_display: 'lineqr',
    state,
    scope: "profile openid",
    nonce
  });
  localStorage.setItem('lineRedirectUrl', window.location.href)
  window.location.href = `https://access.line.me/oauth2/v2.1/authorize?${params}`;
}

watch(() => showLogin.value, (newValue) => {
  loginType.value = 'mobile'
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_vs_button = _resolveComponent("vs-button")!
  const _component_vs_dialog = _resolveComponent("vs-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_vs_dialog, {
      modelValue: showLogin.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showLogin).value = $event)),
      width: "468px",
      onClose: closeDia
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('msg.login.tips_text')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_unref(store).state.user.language=='zh-CN')
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3)),
          (loginType.value == 'wechat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (loginType.value == 'wechat')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (loginType.value == 'mobile')
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 3,
                ref_key: "formRef",
                ref: formRef,
                model: form.value,
                rules: rules.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "mobile" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.mobile,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.mobile) = $event)),
                        type: "text",
                        autocomplete: "off",
                        placeholder: _ctx.$t('msg.login.mobile_pla')
                      }, {
                        prefix: _withCtx(() => [
                          _createElementVNode("span", _hoisted_6, [
                            _cache[8] || (_cache[8] = _createElementVNode("img", {
                              class: "input-prefix",
                              src: _imports_2,
                              alt: ""
                            }, null, -1)),
                            (isCode.value)
                              ? (_openBlock(), _createBlock(_component_el_dropdown, {
                                  key: 0,
                                  onCommand: dropdownSelectedPlatform,
                                  placement: "bottom-start"
                                }, {
                                  dropdown: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_menu, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_item, {
                                          command: "86",
                                          class: _normalizeClass({'dropdown_select': countryCode.value === '86'})
                                        }, {
                                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode("简体中文（人民币支付）")
                                          ])),
                                          _: 1
                                        }, 8, ["class"]),
                                        _createVNode(_component_el_dropdown_item, {
                                          command: "886",
                                          class: _normalizeClass({'dropdown_select': countryCode.value === '886'})
                                        }, {
                                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode("繁體中文（新台幣支付）")
                                          ])),
                                          _: 1
                                        }, 8, ["class"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_7, [
                                      _createElementVNode("span", _hoisted_8, "+" + _toDisplayString(countryCode.value), 1),
                                      _createVNode(_component_el_icon, { style: {"margin-left":"4px"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ArrowDown))
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }),
                  (isCode.value)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: "code"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.value.code,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.code) = $event)),
                            type: "text",
                            autocomplete: "off",
                            placeholder: _ctx.$t('msg.login.code_pla')
                          }, {
                            prefix: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createElementVNode("img", {
                                class: "input-prefix",
                                src: _imports_3,
                                alt: ""
                              }, null, -1)
                            ])),
                            suffix: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "vs-button cursor-pointer vs-button--default",
                                disabled: smsLoading.value,
                                onClick: sendCode
                              }, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(countDown.value > 0 ? `${countDown.value} ${_ctx.$t('msg.login.send_code')}` : _ctx.$t('msg.login.get_code')), 1)
                              ], 8, _hoisted_9)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        prop: "password"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.value.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.password) = $event)),
                            type: "password",
                            autocomplete: "off",
                            placeholder: _ctx.$t('msg.login.password_pla')
                          }, {
                            prefix: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createElementVNode("img", {
                                class: "input-prefix",
                                src: _imports_3,
                                alt: ""
                              }, null, -1)
                            ])),
                            suffix: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('msg.login.forget_password')) + "？", 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["model", "rules"]))
            : _createCommentVNode("", true),
          (loginType.value == 'mobile')
            ? (_openBlock(), _createBlock(_component_vs_button, {
                key: 4,
                block: "",
                class: _normalizeClass(isQuickLogon.value ? 'vs-button--shadow mt24': 'vs-button--active'),
                loading: btnLoading.value,
                onClick: confirmLogin
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(!isCode.value? _ctx.$t('msg.login.password'):_ctx.$t('msg.login.phone_code')) + "登录", 1)
                ]),
                _: 1
              }, 8, ["class", "loading"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (countryCode.value === '86')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "other-item",
                onClick: wechatLogin
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "微信登录", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "other-item",
                onClick: lineLogin
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("img", {
                  src: _imports_5,
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "LINE登录", -1)
              ]))),
          _createElementVNode("div", {
            class: "other-item",
            onClick: _cache[3] || (_cache[3] = ($event: any) => {isCode.value=false; loginType.value = 'mobile'})
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "justifyContentCenter pas-icon" }, [
              _createElementVNode("img", {
                src: _imports_6,
                alt: ""
              })
            ], -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('msg.login.password')) + "登录", 1)
          ]),
          _createElementVNode("div", {
            class: "other-item",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {isCode.value=true; loginType.value = 'mobile'})
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("img", {
              src: _imports_7,
              alt: ""
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('msg.login.phone_code')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})